import { render, staticRenderFns } from "./ImageSwiperPreview.vue?vue&type=template&id=40c2fc05&scoped=true&"
import script from "./ImageSwiperPreview.vue?vue&type=script&lang=js&"
export * from "./ImageSwiperPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImageSwiperPreview.vue?vue&type=style&index=0&id=40c2fc05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2fc05",
  null
  
)

export default component.exports